/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { Event } from '@app/common/event/event';
import { EventWorkItem } from '@app/data-model/event-work-item';
import { NotSupportedException } from '@core/lib/exceptions';
import { EventType } from './event-type';

export class EventMessage {
  private readonly _id: number;
  private readonly _keys: any;
  private readonly _event: Event;
  private _workItem: EventWorkItem[];
  private _params: any;

  constructor(event: Event, eventWorkItem: any, params?: any) {
    this._event = event;
    if (eventWorkItem === null && event.type === EventType.REMOTE) {
      throw new NotSupportedException(
        `EventMessage object is not supported for event communication - ${eventWorkItem}`
      );
    }
    if (eventWorkItem instanceof Array) {
      this._workItem = eventWorkItem;
    } else {
      this._workItem = [eventWorkItem];
    }

    if (params) {
      this._params = params;
    }
  }

  get id(): number {
    return this._id;
  }

  get keys(): any {
    return this._keys;
  }

  get event(): Event {
    return this._event;
  }

  get workItem(): EventWorkItem[] {
    return this._workItem;
  }

  set workItem(workItem) {
    if (workItem instanceof Array) {
      this._workItem = workItem;
    } else {
      this._workItem = [workItem];
    }
  }

  get params(): any {
    return this._params;
  }

  set params(params: any) {
    this._params = params;
  }
}
